import ButtonLoader from "components/common/ButtonLoader";
import CustomField from "components/common/CustomField";
import CustomLabel from "components/common/CustomLabel";
import { orgnisationDetailsSchema } from "components/common/Validation";
import { orgnisationDetailsInitialValues } from "components/constants/InitialFormValues";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { saveCompanyInfo } from "store/actions/authSlice";
import { getAllCountries } from "store/actions/citySlice";
import { showAlert } from "store/reducers/alertReducer";

function OrgnisationForm() {
  const { t } = useTranslation();
  const { isLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { countries } = useSelector((state) => state.Cities);
  const { orgnisationDetails } = useSelector((state) => state.auth);


  const [initialValues, setInitialValues] = useState(
    orgnisationDetailsInitialValues
  );
  useEffect(() => {
    // GET CITY LIST
    const fetchCountryList = () => {
      dispatch(getAllCountries());
    };

    fetchCountryList();
  }, []);
  // console.log(countries)
  const handleOnSubmit = (values) => {
    dispatch(saveCompanyInfo({ companyDetails: values }))
      .then((action) => {
        const { statusCode, success, message, data } = action?.payload || {};

        if (statusCode === 200 && success) {

          dispatch(
            showAlert({
              text: message,
              type: "success",
            })
          );
          navigate(`/dashboards/overview`);
        } else {
          dispatch(
            showAlert({
              text: "Something went wrong",
              type: "error",
            })
          );

        }
      })
      .catch((err) => {
        dispatch(
          showAlert({
            type: "error",
            message: "Something went wrong during signup.",
          })
        );
        console.error("Error in signUp:", err);
      });
  };
  useEffect(() => {
      if(orgnisationDetails.hasSubscriptionEntry && orgnisationDetails.isCompanyDetailsSaved){
        navigate('/dashboards/overview');
      }
    }, [dispatch]);

  return (
    <div className="welcome_pg_bg">
      <div className="container">
        <div className="pg_organizationinfo">
          <div className="of_inner">
            <div className="bold text_white text-center">
              <h2 className="text-black">{t("Your orgnisation info")}</h2>
            </div>
            <div className="orgnisation_form_wrapper">
              <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={orgnisationDetailsSchema}
                onSubmit={handleOnSubmit}
              >
                {({ values, errors, touched, setFieldValue, handleBlur }) => (
                  <Form>
                    <div className="form_field">
                      <CustomLabel htmlFor="email" label={t("Orgnisation Name")} />
                      <CustomField
                        name="companyName"
                        type="text"
                        placeholder={t("Orgnisation Name")}
                        touched={touched}
                        errors={errors}
                      />
                    </div>
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="commercialNumber"
                        label={t("Commercial number")}
                      />
                      <CustomField
                        name="commercialNumber"
                        type="text"
                        placeholder={t("Commercial number")}
                        touched={touched}
                        errors={errors}
                      />
                    </div>
                    <div className="form_field">
                      <CustomLabel htmlFor="password" label={t("Country")} />
                      <select
                        className="form-select"
                        name="countryId"
                        value={values.countryId}
                        onBlur={handleBlur}
                        onChange={(e) =>
                          setFieldValue("countryId", e.target.value)
                        }
                      >
                        <option value="" disabled>
                          {t("Select country")}
                        </option>
                        {countries?.map((country) => (
                          <option key={country.id} value={country.id}>
                            {country.name}{" "}
                            {country.phoneCode && `(${country.phoneCode})`}
                          </option>
                        ))}
                      </select>
                      {errors.countryId && (
                        <div className="text-danger">{errors.countryId}</div>
                      )}
                    </div>
                    <div className="form_field">
                      <CustomLabel htmlFor="password" label={t("Vat number")} />
                      <CustomField
                        name="vatNumber"
                        type="text"
                        placeholder={t("Vat number")}
                        touched={touched}
                        errors={errors}
                      />
                    </div>

                    <button
                      type="submit"
                      className="primary_btn w-100 g_center gap-2"
                      disabled={isLoading}
                    >
                      {t("Save")}
                      {
                        isLoading &&
                        <ButtonLoader />
                      }
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrgnisationForm;
